<template>
  <div class="brand-offers">
    <div class="header-title-wrap-bc">
      <div class="l-container">
        <h1 class="text-h1-bold-up desktop-margin inline">
          Товары {{ data.h1 }}
        </h1>
        <span v-if="count" class="tablet-count text-body-m-book">
          {{ count && tabletCount }}
        </span>
        <HowToBuy class="how-modal-button">
          <UiLink mode="button" responsive-ico icon-after="help-circle">
            Как купить товар
          </UiLink>
        </HowToBuy>
      </div>
    </div>

    <products-with-filters
      v-model:count="count"
      :data="data"
      :page-data="pageData"
      :filters-url="`/brands/${data.brand_id}/filters`"
      :products-url="`/brands/${data.brand_id}/list`"
      where-str="найдено"
      type-page="brand"
      @change-data="(e) => $emit('change-data', e)"
    >
      <template #after-products>
        <model-history />
      </template>
      <template #after-filters>
        <div
          v-if="popularBrands.length"
          class="popular-brands text-mobile-nav-book"
        >
          <div class="title">Популярные бренды</div>
          <nuxt-link
            v-for="(item, index) in popularBrands"
            :key="index"
            :to="`/${item.slug}/`"
            class="text-button"
            @click="clearMobileScroll"
          >
            {{ item?.name }}
          </nuxt-link>
        </div>
      </template>
    </products-with-filters>
  </div>
</template>

<script lang="ts" src="./brandTs.ts"></script>
<style scoped lang="scss" src="./brand.scss"></style>
